export class StretchPopup {
    public static stretch() {
        const popup = $('.popup-stretch');

        popup.each(function stretchPopup() {
            const popup = $(this);
            let middlePartHeight = 0;
            const topPart = popup.find('.popup-stretch__top');
            const middleBgPart = popup.find('.popup-stretch__middle');
            const bottomBgPart = popup.find('.popup-stretch__bottom');
            const contentPart = popup.find('.popup-stretch__content');

            contentPart.css('height', '');

            const topPartBgHeight = topPart.height();
            const bottomPartHeight = bottomBgPart.height();
            const contentPartOuterHeight = contentPart.outerHeight();
            const contentPartHeight = contentPart.height();


            if (topPartBgHeight === undefined ||
                bottomPartHeight === undefined ||
                contentPartOuterHeight === undefined ||
                contentPartHeight === undefined
            ) {
                return; // popup doesn't have all the parts to stretch
            }
            const topPartMargin: number = parseInt(topPart.css('margin-bottom'));

            const bottomPartMargin: number = parseInt(topPart.css('margin-top'));

            middlePartHeight = contentPartOuterHeight - topPartBgHeight -
                bottomPartHeight - topPartMargin - bottomPartMargin;
            middlePartHeight = middlePartHeight >= 0 ? middlePartHeight : 0;
            middlePartHeight = parseInt(middlePartHeight.toFixed());
            middlePartHeight = (middlePartHeight + topPartBgHeight + bottomPartHeight) % 2 === 0
                ? middlePartHeight
                : middlePartHeight + 1;

            middleBgPart.height(middlePartHeight);

            const shouldFixContent: boolean = contentPartOuterHeight % 2 !== 0;

            if (shouldFixContent) {
                contentPart.height(contentPartHeight + 1);
            }
        });
    }
}
